import { Injectable, Injector } from '@angular/core';
import { MenuFilterService } from '../../../../services/menu-filter.service';

export interface NavigationItemInterface {
  id?: string;
  title: string;
  type: string;
  url?: string;
  icon?: string;
  children?: NavigationItemInterface[];
  hidden?: boolean;
  classes?: string;
  badge?: {
    title: string;
    type: string;
  };
  target?: string;
  external?: boolean;
}

const NavigationItems: NavigationItemInterface[] = [
      {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'item',
        url: '/dashboard',
        icon: 'feather icon-home'
      },
      {
        id: 'employees',
        title: 'Employees',
        type: 'collapse',
        icon: 'feather icon-users',
        url: '/employees',
        children: [
          {
            id: 'add-employee',
            title: 'Add Employee',
            type: 'item',
            url: '/employees/add-employee',
            icon: 'feather icon-user-plus'
          },          
          {
            id: 'view-employee',
            title: 'View Employees',
            type: 'item',
            url: '/employees/view-employee',
            icon: 'feather icon-eye'
          },
          {
            id: 'assign-employees',
            title: 'Assign Employees',
            type: 'item',
            url: '/employees/assignments',
            icon: 'feather icon-user-check'
          },
          {
            id: 'roles',
            title: 'Roles',
            type: 'item',
            url: '/employees/roles',
            icon: 'feather icon-shield'
          }
        ]
      },
      
      {
        id: 'attendance',
        title: 'Attendance',
        type: 'collapse',
        icon: 'feather icon-calendar',
        url: '/attendance',
        children: [
          {
            id: 'attendance-report',
            title: 'Attendance Report',
            type: 'item',
            url: '/attendance/report',
            icon: 'feather icon-bar-chart-2'
          },
          {
            id: 'regularize-attendance',
            title: 'Regularize Attendance',
            type: 'item',
            url: '/attendance/regularize',
            icon: 'feather icon-clock'
          }
        ]
      },
      {
        id: 'vendor',
        title: 'Vendors',
        type: 'collapse',
        icon: 'feather icon-shopping-cart',
        url: '/vendors',
        children: [
          {
            id: 'add-vendor',
            title: 'Add Vendor',
            type: 'item',
            url: '/vendors/add',
            icon: 'feather icon-plus-circle'
          },
          {
            id: 'view-vendor',
            title: 'View Vendor',
            type: 'item',
            url: '/vendors/view',
            icon: 'feather icon-list'
          }
        ]
      },
      {
        id: 'customer',
        title: 'Customer Management',
        type: 'collapse',
        icon: 'feather icon-shopping-cart',
        url: undefined, // Remove URL for parent collapse to prevent navigation
        children: [
          {
            id: 'view-customer-groups',
            title: 'Customer Master',
            type: 'item',
            url: '/customer-groups/view',
            icon: 'feather icon-layers'
          },
          {
            id: 'add-customer',
            title: 'Add branch',
            type: 'item',
            url: '/customers/branch/add',
            icon: 'feather icon-plus-circle'
          },
          {
            id: 'view-customers',
            title: 'View branches',
            type: 'item',
            url: '/customers/branch/view',
            icon: 'feather icon-list'
          }
        ]
      },
      {
        id: 'customer-stocks',
        title: 'Customer Stocks',
        type: 'collapse',
        icon: 'feather icon-package',
        url: undefined, // Remove URL for parent collapse to prevent navigation
        children: [
          {
            id: 'stock-in',
            title: 'Stock In',
            type: 'item',
            url: '/stocks/in',
            icon: 'feather icon-package'
          },
          {
            id: 'stock-out',
            title: 'Stock Used Today',
            type: 'item',
            url: '/stocks/out',
            icon: 'feather icon-bar-chart-2'
          },
          {
            id: 'stock-transfer',
            title: 'Stock Transfer',
            type: 'item',
            url: '/stocks/transfer',
            icon: 'feather icon-shuffle'
          },
          {
            id: 'location-floor-stock',
            title: 'Location & floor stock',
            type: 'item',
            url: '/stocks/location-floor-stock',
            icon: 'feather icon-layers'
          },
          {
            id: 'stock-report',
            title: 'Stock Report',
            type: 'item',
            url: '/stocks/report',
            icon: 'feather icon-bar-chart-2'
          },
          {
            id: 'stock-availability-report',
            title: 'Stock Availability Report',
            type: 'item',
            url: '/stocks/availability',
            icon: 'feather icon-clipboard'
          },
          {
            id: 'machine-readings',
            title: 'Machine Readings',
            type: 'item',
            url: '/stocks/machine-readings',
            icon: 'feather icon-activity'
          },
          {
            id: 'return-stock',
            title: 'Return Stock',
            type: 'item',
            url: '/stocks/return-stocks',
            icon: 'feather icon-rotate-ccw'
          }
        ]
      },
      {
        id: 'machines',
        title: 'Machines',
        type: 'collapse',
        icon: 'feather icon-cpu',
        url: '/machines',
        children: [
          {
            id: 'add-machine',
            title: 'Add Machine',
            type: 'item',
            url: '/machines/add',
            icon: 'feather icon-plus'
          },
          {
            id: 'view-machines',
            title: 'View Machines',
            type: 'item',
            url: '/machines/view',
            icon: 'feather icon-monitor'
          },
          {
            id: 'assign-machine-to-customer',
            title: 'Assign Machine to Customer',
            type: 'item',
            url: '/machine-assignment',
            icon: 'feather icon-link'
          }
        ]
      },
      {
        id: 'products',
        title: 'Products',
        type: 'collapse',
        icon: 'feather icon-box',
        url: '/products',
        children: [
          {
            id: 'add-product',
            title: 'Add Product',
            type: 'item',
            url: '/products/add',
            icon: 'feather icon-plus-square'
          },
          {
            id: 'view-products',
            title: 'View Products',
            type: 'item',
            url: '/products/view',
            icon: 'feather icon-grid'
          }
        ]
      },
      {
        id: 'internal-stocks',
        title: 'Internal Stocks',
        type: 'collapse',
        icon: 'feather icon-package',
        url: undefined, // Remove URL for nested collapse to prevent navigation
        children: [
          {
            id: 'delivery-to-customer',
            title: 'Delivery to Customer',
            type: 'item',
            url: '/stocks/delivery-to-customer',
            icon: 'feather icon-shopping-cart'
          },
          {
            id: 'internal-stock-in',
            title: 'Stock In',
            type: 'item',
            url: '/stocks/internal-in',
            icon: 'feather icon-package'
          },
          {
            id: 'internal-stock-availability-report',
            title: 'Internal Stock Availability Report',
            type: 'item',
            url: '/stocks/internal-availability',
            icon: 'feather icon-clipboard'
          },
          {
            id: 'return-stocks',
            title: 'Return Stocks',
            type: 'item',
            url: '/stocks/return-stocks',
            icon: 'feather icon-rotate-ccw'
          }
        ]
      },
      {
        id: 'file-upload',
        title: 'File Upload',
        type: 'item',
        url: '/file-management',
        icon: 'feather icon-upload'
      },
      {
        id: 'deleted-records',
        title: 'Deleted Records',
        type: 'item',
        url: '/deleted-records',
        icon: 'feather icon-trash-2'
      }
];

@Injectable()
export class NavigationItem {
  private menuFilterService: MenuFilterService | null = null;

  constructor(private injector: Injector) {
    // Use Injector to avoid circular dependency
    try {
      this.menuFilterService = this.injector.get(MenuFilterService);
    } catch (e) {
      console.warn('MenuFilterService not available, using unfiltered navigation');
    }
  }

  public get(): NavigationItemInterface[] {
    const items = NavigationItems;
    
    // If MenuFilterService is available, filter items based on privileges
    if (this.menuFilterService) {
      return this.menuFilterService.filterNavigationItems(items);
    }
    
    // Fallback: return unfiltered items
    return items;
  }

  /**
   * Get navigation items without filtering (for admin/super user)
   */
  public getAll(): NavigationItemInterface[] {
    return NavigationItems;
  }
}